var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{attrs:{"href":_vm.buttonLink,"target":"_blank"}},[_c('button',{staticClass:"question-button",style:({ backgroundColor: _vm.theme.primaryColor }),on:{"click":_vm.submit}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }